import React, { useState,useEffect }  from 'react';
import { Scale, Users, Target, BookOpen, Award, Calendar, Plus } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import * as Constants from '../../constants';
import BackLoader from '../../components/backloader';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';


import { Footer } from '../components/Footer';
import { CompactHeader } from '../components/CompactHeader';


export default function AboutPage() {
  const [leadership, setLeadership]=useState([]);
  const [category,setCategory] = useState('Court Leadership');
  const [loading,setLoading] = useState(false);
  useEffect(() => {    
                    onLoadTeam();
                }, []);
  const onLoadTeam=async()=>{
                 try {
                      setLoading(true);
                        const resp = await fetch(`${Constants.apiUrl}/cms/team/${category}`, { 
                          method: 'GET',
                          headers: {
                            'Content-Type': 'application/json',                         
                          },
                        });
                        
                        const data = await resp.json();
                        setLoading(false);
                        if(data.code==0){
                            setLeadership(data.items);
                        }
                       
                      } catch (error) {
                        setLoading(false);
                        console.error(error);
                        
                      }
           }
 const leadershipTeam = [
  {
    name: 'Hon. Justice K.O Alogba',
    title: 'Chief Judge of Lagos State',
    image:`${Constants.baseurl}/assets/landing_images/alogba.png` , // ✅ use the imported variable
    // bio: 'Leading the Lagos State Judiciary with a commitment to justice, transparency, and excellence in judicial administration.',
    // experience: '25+ years'
  },
  {
    name: 'Hon. Justice O.A Ipaye',
    title: 'Administrative Judge Lagos',
    image: `${Constants.baseurl}/assets/landing_images/lpaye.png` ,
    // bio: 'Overseeing administrative functions and ensuring efficient court operations across all divisions.',
    // experience: '20+ years'
  },
  {
    name: 'Hon. Justice A. M Nicol-Clay',
    title: 'Administrative Judge Ikeja',
    image: `${Constants.baseurl}/assets/landing_images/mnicol.png` ,
    // bio: 'Managing court registry operations and maintaining judicial records with the highest standards.',
    // experience: '18+ years'
  },
  {
    name: 'Hon. Justice A.J Coker',
    title: '',
    image: `${Constants.baseurl}/assets/landing_images/ajcoker.png` ,
    // bio: 'Coordinating administrative support services and staff development across the judiciary.',
    // experience: '15+ years'
  }
];

  const coreValues = [
    {
      icon: Scale,
      title: 'Justice',
      description: 'Upholding fairness and impartiality in all judicial proceedings'
    },
    {
      icon: Award,
      title: 'Integrity',
      description: 'Maintaining the highest ethical standards in all our operations'
    },
    {
      icon: Target,
      title: 'Excellence',
      description: 'Striving for the highest quality in judicial service delivery'
    },
    {
      icon: Users,
      title: 'Accessibility',
      description: 'Ensuring justice is accessible to all citizens regardless of background'
    }
  ];

  const achievements = [
    { year: '2023', achievement: 'Implemented E-Filing System across all courts' },
    { year: '2023', achievement: 'Reduced case backlog by 35%' },
    { year: '2022', achievement: 'Launched Virtual Hearing Platform' },
    { year: '2022', achievement: 'Opened 3 new Magistrate Courts' },
    { year: '2021', achievement: 'Digitized over 100,000 court records' },
    { year: '2021', achievement: 'Introduced Multi-Door Courthouse system' }
  ];

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <CompactHeader  />
      {/* Hero Section */}
      <section className="relative py-24 bg-hero-light-image dark:bg-hero-dark">
        {/* <div className="absolute inset-0 bg-black/20"></div> */}
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              About Lagos State Judiciary
            </h1>
            <p className="text-xl md:text-2xl mb-8 leading-relaxed">
              Committed to delivering justice with integrity, accessibility, and excellence for all citizens of Lagos State
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Badge variant="secondary" className="px-4 py-2 text-sm bg-white/20 border-white/30">
                <Calendar className="w-4 h-4 mr-2" />
                Established 1967
              </Badge>
              <Badge variant="secondary" className="px-4 py-2 text-sm bg-white/20 border-white/30">
                <Users className="w-4 h-4 mr-2" />
                200+ Judicial Officers
              </Badge>
              <Badge variant="secondary" className="px-4 py-2 text-sm bg-white/20 border-white/30">
                <Scale className="w-4 h-4 mr-2" />
                70+ Courts
              </Badge>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section id="vision-mission" className="py-20 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
          <div className="grid md:grid-cols-2 gap-12">
            <Card className="border-0 shadow-lg">
              <CardContent className="p-8">
                <div className="flex items-center mb-6">
                  <Target className="h-8 w-8 text-blue-600 mr-3" />
                  <h2 className="text-3xl font-bold text-gray-900 dark:text-white">Our Vision</h2>
                </div>
                <p className="text-lg text-gray-700 dark:text-gray-300 leading-relaxed">
                  To be a world-class judiciary that is accessible, efficient, and transparent in the delivery of justice, 
                  ensuring the rule of law and upholding the rights of all citizens in Lagos State.
                </p>
              </CardContent>
            </Card>

            <Card className="border-0 shadow-lg">
              <CardContent className="p-8">
                <div className="flex items-center mb-6">
                  <BookOpen className="h-8 w-8 text-blue-600 mr-3" />
                  <h2 className="text-3xl font-bold text-gray-900 dark:text-white">Our Mission</h2>
                </div>
                <p className="text-lg text-gray-700 dark:text-gray-300 leading-relaxed">
                  To provide timely, fair, and impartial justice through innovative service delivery, 
                  while maintaining the highest standards of integrity and professionalism in all our judicial processes.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section id="core-values" className="py-20">
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
              Our Core Values
            </h2>
            <p className="text-xl text-gray-600 dark:text-gray-400">
              The principles that guide our commitment to justice
            </p>
          </div>

          <div className="grid md:grid-cols-2 py-2 lg:grid-cols-4 gap-8">
            {coreValues.map((value, index) => (
              <Card key={index} className="text-center border-0 shadow-lg hover:shadow-xl transition-shadow">
                <CardContent className="p-8">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 dark:bg-blue-900 rounded-full mb-6">
                    <value.icon className="h-8 w-8 text-blue-600 dark:text-blue-400" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
                    {value.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                    {value.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Leadership Team Section */}
      <section id="court-leadership" className="py-20 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4 py-2 sm:px-6 max-w-7xl">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
              Leadership Team
            </h2>
            <p className="text-xl text-gray-600 dark:text-gray-400">
              Meet the dedicated leaders steering Lagos State Judiciary
            </p>
          </div>
<div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
  {leadership.map((leader, index) => (
    <Card key={index} className="border-0 shadow-lg hover:shadow-xl transition-shadow group">
      <CardContent className="p-6">
        <div className="aspect-square bg-gradient-to-br from-blue-100 to-blue-200 dark:from-blue-900 dark:to-blue-800 rounded-xl mb-4 overflow-hidden">
          <img
            src={`${Constants.docUrl}/cms/team/${leader.coverImage}`}
            alt={leader.fullName}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        </div>
        <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
          {leader.fullName}
        </h3>
        <p className="text-blue-600 dark:text-blue-400 font-medium mb-3">
          {leader.position}
        </p>
        {/* <p className="text-sm text-gray-600 dark:text-gray-400 mb-3 leading-relaxed">
          {leader.bio}
        </p> */}
        {/* <Badge variant="outline" className="text-xs">
          {leader.experience}
        </Badge> */}
      </CardContent>
    </Card>
  ))}
</div>


        </div>
      </section>

      {/* Strategic Plan & Achievements */}
      <section id="strategic-plan" className="py-20">
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Strategic Plan */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">
                Strategic Plan 2021-2025
              </h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center">
                    <span className="text-blue-600 dark:text-blue-400 font-bold text-sm">1</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Digital Transformation</h3>
                    <p className="text-gray-600 dark:text-gray-400">Complete digitization of court processes and records</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center">
                    <span className="text-blue-600 dark:text-blue-400 font-bold text-sm">2</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Infrastructure Development</h3>
                    <p className="text-gray-600 dark:text-gray-400">Modernize court facilities and expand access points</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center">
                    <span className="text-blue-600 dark:text-blue-400 font-bold text-sm">3</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Capacity Building</h3>
                    <p className="text-gray-600 dark:text-gray-400">Continuous training and development of judicial staff</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center">
                    <span className="text-blue-600 dark:text-blue-400 font-bold text-sm">4</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Public Access</h3>
                    <p className="text-gray-600 dark:text-gray-400">Enhance citizen access to justice through technology</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Recent Achievements */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">
                Recent Achievements
              </h2>
              <div className="space-y-4">
                {achievements.map((achievement, index) => (
                  <Card key={index} className="border-l-4 border-l-blue-600">
                    <CardContent className="p-4">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-gray-900 dark:text-white font-medium">
                            {achievement.achievement}
                          </p>
                        </div>
                        <Badge variant="secondary" className="ml-4">
                          {achievement.year}
                        </Badge>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
{/* Strategic Plan & Achievements - ACCORDION SECTION */}
      <section id="strategic-plan-achievements" className="py-20 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
              About High Court of Lagos State
            </h2>
            {/* <p className="text-xl text-gray-600 dark:text-gray-400">
              Key goals and milestones in our commitment to excellence
            </p> */}
          </div>

          {/* Accordion Component */}
          <Accordion type="single" collapsible className="w-full max-w-4xl mx-auto shadow-xl rounded-lg overflow-hidden">
            {/* 1. Strategic Plan Accordion Item */}
            <AccordionItem value="item-1" className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700">
              <AccordionTrigger className="p-6 text-xl font-semibold hover:bg-blue-50 dark:hover:bg-gray-700 transition-colors">
                <div className="flex items-center">
                  <Plus className="w-6 h-6 text-blue-600 mr-3" />
                 Lagos State Court System
                </div>
              </AccordionTrigger>
              <AccordionContent className="p-6 bg-gray-50 dark:bg-gray-800">
               <div className="text-gray-700 dark:text-gray-300 leading-relaxed space-y-4">
                            <p>
                                The Lagos State Judiciary is the oldest Judiciary in Nigeria. Its existence dates back to the period of the Cession of Lagos to the British Government when it was established and known as the **Colony Province Judiciary**.
                            </p>
                            <p className="p-3 bg-blue-50 dark:bg-blue-950 border-l-4 border-blue-500 rounded-md">
                                The First Court to be established was the Magistrates' Court. When the High Court was established later, it was called the Supreme Court and its jurisdiction was limited to Lagos. At self-government, the Federal Territory of Lagos inherited the two systems of Courts - the Magistrates' Courts and the Supreme Court.
                            </p>
                            <p>
                                At the creation of the Federal Supreme Court, the Lagos Supreme Court became High Court of the Federal Territory Lagos. Hon. Justice Conrad Idowu Taylor became Chief Justice of the Court on the **22nd day of July 1964**. The High Court building in Lagos (at Race Course) was the headquarters of the Court and is the oldest and most recognizable Judicial Building in Nigeria.
                            </p>
                            <p className="p-3 bg-green-50 dark:bg-green-950 border-l-4 border-green-500 rounded-md font-medium">
                                When Lagos State was created as one of the twelve states by virtue of provisions of the States (Creation and Transitional Provisions) Decree No. 4 of 1967, which came into effect on 27th May 1967, the High Court and the Magistrate Court of the Federal Territory were merged with the High Court and Magistrate Court of the former Western Region then at Ikeja. This became the Lagos State Judiciary and Hon. Justice Conrad Idowu Taylor became the first Chief Justice of Lagos State. Today, the title of that office is Chief Judge of Lagos State.
                            </p>
                            <p>
                                Hon. Justice Taylor ceased to be the Chief Judge on the 7th day of November 1973.
                            </p>
                        </div>
                        <div className="grid md:grid-cols-2 gap-6">
                
                <div className="bg-white dark:bg-gray-900 p-6 rounded-xl shadow-md border-t-4 border-green-500">
                  
                    <ul className="list-disc list-inside space-y-1 ml-4 text-sm text-gray-600 dark:text-gray-400">
                        <li>Hon. Justice J.A. Adefarasin                         1st day of November 1974 to 24th day of April 1985.</li>
                        <li>Hon. Justice Candide A. Johnson                  25th day of April 1985 to 1st day of July 1989.</li>
                        <li>Hon. Justice Ligali Ayorinde.                        1st  July 1989 to 10th day of April 1995.</li>
                        <li>The first female Chief Judge Hon. Justice Rosaline Omotosho (Mrs) 12th day of April 1995 to 27th day of February 1996.</li>
                        <li>Hon. Justice Olusola Thomas.                       15th day of March 1996 to 26th day of November 1996.</li>
                        <li>Hon. Justice S.O. Ilori.                                 27th day of December 1996 to 5th day of January 1999.</li>
                        <li>Hon. Justice Sikiru Adagun.                           3rd day of May 1999 to 22nd day of May 1999.</li>
                        <li>Hon. Justice Christopher Olatunde Segun.       24th day of May 1999 to 25th day of May 2001.</li>
                    </ul>
                </div>

                <div className="bg-white dark:bg-gray-900 p-6 rounded-xl shadow-md border-t-4 border-red-500">
                   <ul className="list-disc list-inside space-y-1 ml-4 text-sm text-gray-600 dark:text-gray-400">
                        <li>Hon. Justice I.A Sotuminu (Mrs) OON.           28th day of May 2001 to 5th day of March 2004.</li>
                        <li>Hon. Justice Afolabi Adeyinka.                       8th day of March 2004 to 22nd day of July 2004.</li>
                        <li>Hon. Justice Augustine Adetula Ade-Alabi OFR. 8th day of July 2004 to 7th day of August 2009.</li>
                        <li>Hon. Justice Inumidun Enitan Akande (Mrs) OFR. 8th September, 2009 to 10 June, 2012.</li>
                        <li>Hon. Justice Ayotunde Adeyoola Phillips (Mrs] 14th day of June, 2012, to 26th day of July 2014.</li>
                        <li>Hon. Justice Funmilayo Atilade.                         20th day of August 2014, to 24th day of September 2017.</li>
                        <li>Hon Justice Opeyemi Oke   20th day of October 2017 to 10th day of June 2019</li> 
                    </ul>
                </div>
            </div>
                    <div className="text-gray-700 dark:text-gray-300 leading-relaxed space-y-4">
                          <p>
                            The present Chief Judge of Lagos state Hon. Justice Kazeem Alogba  was sworn in as the 17th Chief Judge of Lagos State on the 20th day of August 2019
                          </p>
                          <p>
                            The Chief Judge is the head of Courts and as at January 2019, there are fifty-nine (59) Hon. Judges and One Hundred and Fifty-Three (153) Magistrates in the Lagos State Judiciary.
                          </p>
                          <p>
                            The Lagos State Judiciary encompasses, High Courts, Magistrate Courts and Customary Courts each with its own Rules.
                          </p>
                          <p>
                            The Chief Registrar of the High Court of Lagos State is the Head of Administration, Chief Accounting Officer, Probate Registrar, Sheriff, Official Receiver and the Tax Master. Other Principal Officers are the Deputy Chief Registrars in the Ikeja and Lagos Divisions, Director of Admin and Human Resources, Director of Finance & Accounts and Director of Library Services.
                          </p>
              
                </div>
              </AccordionContent>
            </AccordionItem>

            {/* 2. Recent Achievements Accordion Item */}
            <AccordionItem value="item-2" className="bg-white dark:bg-gray-900">
              <AccordionTrigger className="p-6 text-xl font-semibold hover:bg-blue-50 dark:hover:bg-gray-700 transition-colors">
                <div className="flex items-center">
                  <Award className="w-6 h-6 text-blue-600 mr-3" />
                  Lagos State Judiciary Organogram
                </div>
              </AccordionTrigger>
              <AccordionContent className="p-6 bg-gray-50 dark:bg-gray-800">
                <div className="space-y-4">
                  
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
          {/* End of Accordion Component */}

        </div>
      </section>
      {/* Call to Action */}
      <section className="py-20 bg-blue-600 text-white">
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl text-center">
          <h2 className="text-3xl font-bold mb-6">
            Learn More About Our Work
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Explore our annual reports, court statistics, and transparency initiatives
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button variant="secondary" size="lg">
              Download Annual Report
            </Button>
        
          </div>
        </div>
      </section>
       <Footer />
       <BackLoader open={loading} />
    </div>
  );
}